import styled from 'styled-components'

export const ManagePickupTimesButtons = styled.div`
  overflow: hidden;
  padding: 0 35px;
  margin-top: 30px;

  .cancelButton {
    float: left;
    margin-left: -10px;
  }
  .saveButton {
    float: right;
    margin-right: -15px;
  }
`
